import { baseApi } from "@/redux/api/baseApi";

export type LeadCategory =
  | "grounding_guide_333"
  | "pause_reset_blueprint"
  | "anti_burnout_weekly_planner"
  | "three_minute_parental_stress";

interface CreateLeadRequest {
  fullName: string;
  email: string;
  source: "CTA" | "POPUP" | "SLIDEUP" | "NEWSLETTER";
  category?: LeadCategory;
}

interface CreateLeadResponse {
  success: boolean;
  statusCode: number;
  message: string;
}

const leadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createLead: builder.mutation<CreateLeadResponse, CreateLeadRequest>({
      query: (data) => ({
        url: "/leads",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useCreateLeadMutation } = leadApi;
